
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button navUser-action',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container navUser-icon' }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-garage' })), this.size ? _createElement('span', {
        'className': 'garage-size countPill',
        'key': '258'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _createElement('span', { 'className': 'navUser-text' }, _translate(`garage_title`)))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, _createElement('i', { 'className': 'icon' }, _createElement('svg', {}, _createElement('use', { 'xlinkHref': '#icon-close' })))));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'login-dropdown cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '46'
            }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), _createElement('div', { 'className': 'garage-content' }, _createElement('div', { 'className': 'vehicle-submit' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'button cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]))) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1290'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', { 'className': 'vehicle-submit' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'button cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]), _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, '\n        ', _translate(`garage_info_line_one`), '\n        ', _createElement('i', { 'className': 'icon' }, _createElement('svg', {}, _createElement('use', { 'xlinkHref': '#icon-check' })))), _createElement('li', { 'className': 'vehicle-advantages' }, '\n        ', _translate(`garage_info_line_two`), '\n        ', _createElement('i', { 'className': 'icon' }, _createElement('svg', {}, _createElement('use', { 'xlinkHref': '#icon-check' })))), _createElement('li', { 'className': 'vehicle-advantages' }, '\n        ', _translate(`garage_info_line_three`), '\n        ', _createElement('i', { 'className': 'icon' }, _createElement('svg', {}, _createElement('use', { 'xlinkHref': '#icon-check' }))))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]